import { useSyncExternalStore } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const subscribe = (callback) => {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
};

const getSnapshot = () => window.matchMedia(QUERY).matches;

/**
 * During prerender there is no matchMedia, so the server snapshot reports
 * "motion is fine". That matches the stylesheet, which treats reduced
 * motion as an override applied on top of the animated default.
 */
const getServerSnapshot = () => false;

/**
 * Live reduced-motion preference. useSyncExternalStore rather than an
 * effect + useState so a visitor who flips the OS setting mid-session gets
 * the new behaviour without a reload.
 */
export function usePrefersReducedMotion() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
